

export const fetchJson = (url:string, data:any, cb:Function ) => {
  fetch(url).then( resp=>{
    resp.json().then( data=>{
      cb(data);
    })
  })

}


  /**
   * Parse the passed variables from the URL
   * 
   * @memberof dataLoader
   */
export const urlVariables = () => {
    let res = {};
    if (document.location.toString().indexOf('?') !== -1) {
      var query = document.location
        .toString()
        // get the query string
        .replace(/^.*?\?/, '')
        // and remove any existing hash string (thanks, @vrijdenker)
        .replace(/#.*$/, '')
        .split('&');

      for (var i = 0, l = query.length; i < l; i++) {
        var aux = decodeURIComponent(query[i]).split('=');
        res[aux[0].toLowerCase()] = aux[1];
      }

      
    }
    return res
  }
